import React, { useEffect } from "react";
import { motion } from "framer-motion";
import "./Splash.css";

const HOLD_MS = 2200;
const CURTAIN_EASE = [0.76, 0, 0.24, 1];

function Splash({ onDone }) {
  useEffect(() => {
    const timer = setTimeout(onDone, HOLD_MS);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      clearTimeout(timer);
      document.body.style.overflow = previousOverflow;
    };
  }, [onDone]);

  return (
    <div className="splash" role="presentation">
      <motion.div
        className="splash__panel splash__panel--top"
        exit={{ y: "-100%" }}
        transition={{ duration: 0.9, ease: CURTAIN_EASE }}
      />
      <motion.div
        className="splash__panel splash__panel--bottom"
        exit={{ y: "100%" }}
        transition={{ duration: 0.9, ease: CURTAIN_EASE }}
      />
      <motion.div
        className="splash__content"
        exit={{ opacity: 0, scale: 1.15 }}
        transition={{ duration: 0.5, ease: "easeIn" }}
      >
        <motion.h2
          className="splash__title"
          initial={{ opacity: 0, letterSpacing: "0.6em" }}
          animate={{ opacity: 1, letterSpacing: "0.18em" }}
          transition={{ duration: 1.4, ease: "easeOut" }}
        >
          CRISTAL INOX
        </motion.h2>
        <motion.span
          className="splash__line"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ delay: 0.6, duration: 0.9, ease: "easeOut" }}
        />
        <motion.p
          className="splash__tagline"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 0.7 }}
        >
          Chaudronnerie inox
        </motion.p>
      </motion.div>
    </div>
  );
}

export default Splash;
